import axios from "../http";

class InvoiceInfo {
  // 保存税率
  static postSaveTaxRate(data) {
    const url = `/zwy/api/cb/logistics/project/save/tax/rate`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 税率详情
  static getTaxRateList() {
    const url = `/zwy/api/cb/logistics/project/get/tax/rate`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 保存汇率
  static postSaveExchangeRate(data) {
    const url = `/zwy/api/cb/logistics/project/save/exchange/rate`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 汇率详情
  static getExchangeRate() {
    const url = `/zwy/api/cb/logistics/project/get/exchange/rate`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 银行账号列表
  static getBankAccountNumberList() {
    const url = `/zwy/api/cb/logistics/project/bank/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启/关闭银行账号
  static postUpdateBankAccountNumberStatus(id) {
    const url = `/zwy/api/cb/logistics/project/update/bank/status/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增银行账号
  static postAddBankAccountNumber(data) {
    const url = `/zwy/api/cb/logistics/project/save/bank`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑银行账号
  static postModBankAccountNumber(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/bank/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default InvoiceInfo;
